(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mini-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.mrv').forEach(function (root) {
    var track = root.querySelector('[data-mrv-track]'), dots = root.querySelector('[data-mrv-dots]');
    if (!track || !dots) return;
    var cards = track.querySelectorAll('.mrv__card'); if (cards.length < 2) return;
    var ds = []; cards.forEach(function () { var d = document.createElement('i'); dots.appendChild(d); ds.push(d); });
    function sync() { var w = cards[0].offsetWidth + 10; var i = Math.min(cards.length - 1, Math.round(track.scrollLeft / w)); ds.forEach(function (d, n) { d.classList.toggle('on', n === i); }); }
    track.addEventListener('scroll', sync, { passive: true }); sync();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["xmas-delivery-line"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.xdl[data-cutoff]').forEach(function (el) {
    var c = el.dataset.cutoff; if (!/^\d{4}-\d{2}-\d{2}$/.test(c)) return;
    var now = new Date(); var today = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
    if (today > c) { var t = el.querySelector('[data-xdl-text]'); if (t && el.dataset.after) t.textContent = el.dataset.after; }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
